export default __webpack_public_path__ + "static/media/pg-7.e76cac6c.jpg";